import { VuexModuleFactory } from '@/store/VuexModuleFactory';
import { TypedMutationTree, TypedActionTree, TypedGetterTree } from '@/store/CustomFundamentalStoreContracts';
import { IMasterdataMutations, IMasterdataState, IMasterdataActions, IMasterdataGetters } from './masterdataTypes';
import { IRootState } from '@/store/root/rootTypes';
import { masterdataApiService } from '../../../services/masterdata-api.service';
import { LoadableList } from '@/shared/BasicTypes';

const masterdataMutations: TypedMutationTree<IMasterdataMutations, IMasterdataState> = {
  SET_OCIS(state, payload) {
    state.ocis.content = payload;
  },
};

const masterdataActions: TypedActionTree<
  IMasterdataActions,
  IMasterdataMutations,
  IMasterdataGetters,
  IMasterdataState,
  IRootState
> = {
  fetchOcis: async ({ commit, state }) => {
    if (!state.ocis.loaded) {
      const ocis = await masterdataApiService.getOcis();
      commit('SET_OCIS', ocis);
    }
  },
};

const masterdataGetters: TypedGetterTree<IMasterdataGetters, IMasterdataState, IRootState> = {
  ocis: (state) => state.ocis.content,
  findOciById: (state) => (id) => state.ocis.content.find((oci) => oci.id === id),
};

const masterdataState: IMasterdataState = {
  ocis: new LoadableList(),
};

export default new VuexModuleFactory<
  IMasterdataState,
  IRootState,
  IMasterdataActions,
  IMasterdataMutations,
  IMasterdataGetters
>('masterdata', masterdataState, {
  actions: masterdataActions,
  getters: masterdataGetters,
  mutations: masterdataMutations,
});
